export default __webpack_public_path__ + "static/Tek_Gauntlets-43ce0e71b91b607ac77809dad9a51e4a.png";